import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function formatAiResponse(text, file_hash) {
  if (!text) return '';
  return text.replace(/(PAGE|page)_(\d+)/g, (match, p1, p2) => {
    const pageNum = parseInt(p2, 10);
    if (pageNum <= 0) return `**PAG ${p2}**`;
    const url = `https://api.serviceapplications.net/AppDocu/feasibility/showPage?hash=${file_hash}&page=${pageNum}`;
    return `[**PAG ${p2}**](${url})`;
  });
}

/**
 * MarkdownRenderer component
 * Props:
 * - children: markdown text
 * - onDocClick: function(docHash)
 * - userRole: 'user'|'assistant' (optional) used for link color
 */
export function MarkdownRenderer({ children, onDocClick, userRole }){
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        p: ({node, ...props}) => <p style={{ margin:0 }} {...props} />,
        a: ({node, href, ...props}) => {
          if(href && href.startsWith('doc://')){
            return <a {...props} href="#" onClick={(e)=>{ e.preventDefault(); if(onDocClick) onDocClick(href.replace('doc://','')); }} style={{ color: userRole==='user'? 'white':'#1976d2', textDecoration:'underline' }} />;
          }
          return <a href={href} {...props} target="_blank" rel="noopener noreferrer" />;
        }
      }}
    >{children}</ReactMarkdown>
  );
}
